import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { ChecklistTemplateDto } from 'src/types/checklist-template.types';

import { ChecklistCreationFormWrapper } from '../../Forms/Checklist/ChecklistCreationFormWrapper';

const CreateChecklistDrawer = () => {
  const { t } = useTranslation();

  const assetId = useCurrentAssetId();
  const location = useLocation();
  const template = (location.state as { template?: ChecklistTemplateDto } | null)?.template;

  return (
    <AnimatedRoutedDrawer
      title={t('checklist.createChecklist', 'Ajouter une checklist')}
      to={`/asset/${assetId}/guides/checklists`}
    >
      {({ onClose }) => (
        <ChecklistCreationFormWrapper onCreate={onClose} onCancel={onClose} template={template} />
      )}
    </AnimatedRoutedDrawer>
  );
};

export default CreateChecklistDrawer;
